import { Component, Input, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-scoring-cell',
    templateUrl: './scoring-cell.component.html',
    styleUrls: ['./scoring-cell.component.scss'],
    standalone: false,
})
export class ScoringCellComponent implements ICellRendererAngularComp, OnInit {
    @Input() params: ICellRendererParams;
    @Input() showName = false;

    colorClass = 'green';
    colorDescriptor = 'Good';

    constructor() {
        this.agInit(this.params);
    }

    agInit(params: ICellRendererParams): void {
        if (!this.params) {
            this.params = params;
        }

        if (this.params?.data) {
            this.colorClass = this.params?.data?.healthColor?.toLowerCase();
            this.colorDescriptor = this.params?.data?.healthDescriptor;
        }
    }

    ngOnInit(): void {
        if (this.params) {
            this.colorClass = this.params?.data?.healthColor?.toLowerCase();
            this.colorDescriptor = this.params?.data?.healthDescriptor;
        }
    }

    refresh(input: ICellRendererParams) {
        return true;
    }
}
